import { render, staticRenderFns } from "./SecuritiesDeletionAction.vue?vue&type=template&id=f2ac65a0&scoped=true&"
import script from "./SecuritiesDeletionAction.vue?vue&type=script&lang=ts&"
export * from "./SecuritiesDeletionAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ac65a0",
  null
  
)

export default component.exports